module.exports = "/images/home-buy.png?37d6cf25454b493c95c500a80d3d43db";